import { render, staticRenderFns } from "./SearchFilterTokens.vue?vue&type=template&id=fdfe8146&scoped=true&"
import script from "./SearchFilterTokens.vue?vue&type=script&lang=js&"
export * from "./SearchFilterTokens.vue?vue&type=script&lang=js&"
import style0 from "./SearchFilterTokens.vue?vue&type=style&index=0&id=fdfe8146&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fdfe8146",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('fdfe8146')) {
      api.createRecord('fdfe8146', component.options)
    } else {
      api.reload('fdfe8146', component.options)
    }
    module.hot.accept("./SearchFilterTokens.vue?vue&type=template&id=fdfe8146&scoped=true&", function () {
      api.rerender('fdfe8146', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2TN2Ec1A9uoO2/JS/comp/SearchFilterTokens.vue"
export default component.exports